import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@mui/material';
import CircularProgress from '../ui/controls/circularProgress';
import { getCodes } from '../../features/advisor/advisor.slice';
import { useTitle } from '../../hooks/titleProvider';
import { styled } from '@mui/system';

// Styled Components for consistent styling
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  borderBottom: 'none',
  padding: theme.spacing(1)
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(even)': {
    backgroundColor: theme.palette.action.hover
  },
  '&:first-of-type': {
    '& th': {
      borderBottom: `2px solid ${theme.palette.divider}` // Adds the bottom line under the header row
    }
  }
}));

function BrokerCodes() {
  const dispatch = useDispatch();
  const advisorCodes = useSelector((state) => state.advisor.codes);
  const loadingCodes = useSelector((state) => state.advisor.loadingCodes);

  const { setTitle } = useTitle();
  setTitle(`My Clients`);

  useEffect(() => {
    dispatch(getCodes());
  }, [dispatch]);

  return loadingCodes ? (
    <CircularProgress caption="Loading your codes..." />
  ) : (
    <Paper sx={{ padding: 3, borderRadius: 2 }}>
      <Typography sx={{ mb: 2 }} variant="h5" component="h1">
        My Codes
      </Typography>
      {advisorCodes && advisorCodes.length > 0 ? (
        <TableContainer>
          <Table sx={{ border: 'none' }}>
            <TableHead>
              <StyledTableRow sx={{ marginBottom: 2 }}>
                <StyledTableCell>Code</StyledTableCell>
                <StyledTableCell>Provider</StyledTableCell>
              </StyledTableRow>
            </TableHead>
            <TableBody>
              {advisorCodes.map((code, index) => (
                <StyledTableRow key={code.ifaCodeId.code}>
                  <StyledTableCell>{code.ifaCodeId.code}</StyledTableCell>
                  <StyledTableCell>{code.provider.name}</StyledTableCell>
                </StyledTableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      ) : (
        <Typography variant="h6">No Codes Found</Typography>
      )}
    </Paper>
  );
}

export default BrokerCodes;
